import React from 'react'
import { Box, Flex } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'

import useLanguage from '../../../contexts/language/LanguageContext'
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type'
import { getTranslationByPath } from '../../../utils/translations'
import { MainContent } from '../../../layout/content/MainContent'
import { Footer } from '../../../layout/footer/Footer'

export type BozpTrainingRegistrationTemplateType = {
  transitionUrl: TransitionUrl
  checkImage: string
  mobileImage: string
  registrationSuccessText: TranslationPath
  infoText: TranslationPath
}

type Props = {
  page: Page<BozpTrainingRegistrationTemplateType>
}

export const BozpTrainingRegistrationTemplate = (props: Props): React.ReactElement => {
  const language = useLanguage()
  const navigate = useNavigate()

  return (
    <>
      <MainContent>
        <Flex direction="column" gap="1" width="100%" className="items-center">
          <Box maxWidth="500px" className="w-full flex flex-col items-center text-center">
            <img src={`${process.env.APP_DATA_LINK + props.page.data.checkImage}`} className="w-16 h-16 mb-5" alt="" />
            <div
              dangerouslySetInnerHTML={{
                __html: getTranslationByPath(language.translations, props.page.data.registrationSuccessText),
              }}
            />
            <img
              src={`${process.env.APP_DATA_LINK + props.page.data.mobileImage}`}
              className="w-16 h-16 mb-5 mt-10"
              alt=""
            />
            <div
              dangerouslySetInnerHTML={{
                __html: getTranslationByPath(language.translations, props.page.data.infoText),
              }}
            />
          </Box>
        </Flex>
      </MainContent>

      <Footer
        onContinue={() => {
          navigate(props.page.data.transitionUrl, { state: { fromRegistration: true }, replace: true })
        }}
      />
    </>
  )
}
